import { render } from "./company-info-item.vue?vue&type=template&id=001614d2"
import script from "./company-info-item.vue?vue&type=script&lang=js"
export * from "./company-info-item.vue?vue&type=script&lang=js"

import exportComponent from "/home/workspace/cf-dkf-web-micro-base-interior-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__